import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';
export function HalfImageHalfTextCardText({
  children
}) {
  return /*#__PURE__*/React.createElement(S.Text, null, children);
}
HalfImageHalfTextCardText.propTypes = {
  children: PropTypes.node.isRequired
};